import {
  yandere,
  safebooru,
  danbooru,
  wallheaven,
  sendToKawanime,
  civitAi,
} from "../services/connectBFF";
import { mapState, mapActions } from "vuex";

export default {
  computed: {
    ...mapState("options", ["options"]),
  },
  methods: {
    ...mapActions("listPictures", ["setListPictures", "clearListPictures"]),

    async handleConnectTarget(textSearch, page, adminPermission) {
      switch (this.options.target) {
        case "wallheaven":
          await this.handleWallheaven(textSearch, page);
          break;

        case "safebooru":
          await this.handleSafebooru(textSearch, page);
          break;

        case "yande.re":
          await this.handleYandere(textSearch, page, adminPermission);
          break;

        case "danbooru":
          await this.handleDanbooru(textSearch, page);
          break;

        case "civitai":
          await this.handleCivitAi(textSearch, page);
          break;
      }
    },
    async handleWallheaven(textSearch, page) {
      const params = {
        source: "wallheaven",
        q: textSearch || "",
        general: this.options.general,
        anime: this.options.anime,
        people: this.options.people,
        sfw: this.options.sfw,
        sketchy: this.options.sketchy,
        nsfw: this.options.nsfw,
        sorting: "date_added",
        colors: "",
        page: page,
      };

      const request = await wallheaven.get("", { params: { ...params } });
      this.setListPictures(request.data);
    },

    async handleSafebooru(textSearch, page) {
      const params = {
        limit: 64,
        tags: `${textSearch} rating:general`,
        page: page,
      };

      const request = await safebooru.get("", { params: { ...params } });
      this.setListPictures(request.data);
    },

    async handleDanbooru(textSearch, page) {
      const params = {
        limit: 64,
        // tags: `${textSearch} rating:explicit`,
        tags: `${textSearch}`,
        page: page,
      };

      const request = await danbooru.get("", { params: { ...params } });
      this.setListPictures(request.data);
    },

    async handleCivitAi(textSearch, page) {
      const params = {
        sort: "Newest",
        nsfw: "true",
        modelId: "6174,6755,43331,58390",
        // limit: 64,
        // tags: `${textSearch} rating:explicit`,
        // tags: `${textSearch}`,
        page: page,
      };

      const request = await civitAi.get("", { params: { ...params } });
      this.setListPictures(request.data);
    },

    async handleYandere(textSearch, page, adminPermission) {
      let rating = "rating:s";

      if (adminPermission) {
        if (textSearch.includes("rating")) {
          rating = "";
        }
      }

      const params = {
        limit: 64,
        tags: `${textSearch} ${rating}`,
        page: page,
      };

      const request = await yandere.get("", { params: { ...params } });
      this.setListPictures(request.data);
    },

    async handleSendToKawanime(list) {
      await sendToKawanime.post("", list);
    },
  },
};
